import TagsInput from 'react-tagsinput'
import './Tags.scss'

interface IProps {
    value?: any,
    name?: any,
    onChange?: any,
    disabled?: any,
    onFocus?: any,
    onhover?: any,
    addOnBlur?: any,
    inputProps?: any,
    onlyUnique?: any,
    inputValue?: any,
    onChangeInput?: any
}
const TagInput = (props: IProps) => {
    return <TagsInput
        value={props?.value}
        name={props?.name}
        onChange={props?.onChange}
        disabled={props?.disabled}
        onFocus={props?.onFocus}
        onhover={props?.onhover}
        addOnBlur = {props?.addOnBlur}
        inputProps = {props?.inputProps}
        onlyUnique = {props?.onlyUnique}
        inputValue = {props?.inputValue}
        onChangeInput = {props?.onChangeInput}
        >
    </TagsInput>
}

export default TagInput